const env = process.env;

export const Config = {
  DEBUG: env.NODE_ENV ? env.NODE_ENV === 'development' : true,
  API_BASE_URL: env.REACT_APP_API_BASE_URL || 'http://localhost:5000/', // 'http://192.168.2.89:5000/' for nick's pc
  JIRA_BASE_URL: 'https://preeosoftware.atlassian.net/',
};
